<template>
  <div class="rich-text-container">
    <div class="ql-container ql-snow">
      <div class="ql-editor">
        <div v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: ""
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang='scss' scoped>
.rich-text-container {
  background: #fff;
  min-height: 280px;
  .ql-container.ql-snow {
    border: none;
  }
}
</style>
